/**
 * Correlation ids come from request headers and cookies, which a caller controls, and are written
 * to logs and forwarded upstream as X-Correlation-ID. Anything outside this shape (newlines,
 * spaces, JSON, very long values) is discarded and a fresh id minted, so a caller cannot forge log
 * lines or smuggle values into upstream headers.
 *
 * Kept in its own module so it stays importable where generateCorrelationId is mocked.
 */
export const CORRELATION_ID_PATTERN = /^[\w-]{1,64}$/;

export const isValidCorrelationId = (value: unknown): value is string =>
    typeof value === 'string' && CORRELATION_ID_PATTERN.test(value);
